import { Component, Link } from '@mna/react'
import LoadingScreen from 'features/LoadingScreen'
import Results from 'pages/find-care-options/emergency/Results'
import emergencyServiceProviders from 'server/triage/actions/test/getEmergencyResultsRes'

export default class EmergencySection extends Component {

  state = {
    isLoading: true
  }

  async componentDidMount() {

    const { state, actions } = this.props

    try {

      actions.setTriageResponse({
        emergencySessionResults: actions.processEmergencyServiceProviders({ emergencyServiceProviders })
      })

      this.setState({ isLoading: false })

      //actions.submitTriageSession()

    } catch(e) {
      console.log(e)
    }

  }

  render() {

    return (
      <LoadingScreen isLoading={this.state.isLoading}>
        <Results {...this.props} />
      </LoadingScreen>
    )
  }
}
